import { Fragment } from "react";
import { Container, Row } from "reactstrap";
import { Apps, ToDoHeading } from "../../../constants";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import ToDoSidebar from "./toDoSidebar/ToDoSidebar";
import ToDoBody from "./toDoBody/ToDoBody";

const ToDoContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={ToDoHeading} parent={Apps} />
      <Container fluid className="message-wrap bookmark-wrap todo-wrap">
        <Row>
          <ToDoSidebar />
          <ToDoBody />
        </Row>
      </Container>
    </Fragment>
  );
};

export default ToDoContainer;
